import { gql } from '@apollo/client';

export const GET_PORTAL_BILLS = gql`
    query GetPortalBills(
        $billStatus: String
        $startDate: LocalDate
        $endDate: LocalDate
        $timezone: String
        $page: Int
        $size: Int
    ) {
        portalBills(
            billStatus: $billStatus
            startDate: $startDate
            endDate: $endDate
            timezone: $timezone
            page: $page
            size: $size
        ) {
            content {
                billId
                billType
                billTypeLabel
                clientName
                billStatus
                billStatusLabel
                billAmount
                currency
                periodStart
                periodEnd
                timeZone
                orderCount
                exportTemplate
            }
            totalElements
            totalPages
            page
            size
        }
    }
`;

export const GET_PORTAL_BILL_DETAIL = gql`
    query GetPortalBillDetail($billId: ID!) {
        portalBillDetail(billId: $billId) {
            billId
            billType
            billTypeLabel
            clientName
            billStatus
            billStatusLabel
            billAmount
            currency
            periodStart
            periodEnd
            timeZone
            orderCount
            exportTemplate
            feeSummaries {
                feeItemId
                feeItemName
                totalAmount
                amountSign
            }
        }
    }
`;

export const GET_PORTAL_BILL_EXPORT_PROGRESS = gql`
    query GetPortalBillExportProgress($taskId: ID!) {
        portalBillExportProgress(taskId: $taskId) {
            taskId
            status
            progress
            currentStep
            totalRecords
            processedRecords
            errorMessage
            fileName
            fileSize
            fileType
        }
    }
`;

export const GET_PORTAL_BILL_EXPORT_DOWNLOAD_URL = gql`
    query GetPortalBillExportDownloadUrl($taskId: ID!) {
        portalBillExportDownloadUrl(taskId: $taskId)
    }
`;

export const GET_PORTAL_BILL_EXPORT_HISTORY = gql`
    query GetPortalBillExportHistory($billId: ID!, $page: Int, $size: Int) {
        portalBillExportHistory(billId: $billId, page: $page, size: $size) {
            content {
                taskId
                status
                fileName
                fileSize
                createdAt
                completedAt
            }
            totalElements
            page
            size
        }
    }
`;
